
import React from 'react'
import { withFirestore } from 'react-firestore'
import MsgNetLoading from '../components/MsgNetLoading'
import EventoList from '../components/EventoList'

class EventoListScreen extends React.Component {
  // ...
  constructor (props) {
    super(props)
    this.state = {
      eventos: [],
      isLoading: true
    }
  }

  componentDidMount () {
    const { firestore } = this.props

    firestore.collection('evento/')
      .where('visible', '==', true)
      .orderBy('fecha_inicio').orderBy('hora_inicio')
      .onSnapshot((snapshot) => {
        let eventos = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        this.setState({
          eventos: eventos,
          isLoading: false
        })
      })
  }

  render () {
    if (this.state.isLoading) {
      return <MsgNetLoading />
    } else {
      return <EventoList eventos={this.state.eventos} />
    }
  }
}

export default withFirestore(EventoListScreen)



// WEBPACK FOOTER //
// ./src/containers/EventoListScreen.js